import React, { useMemo } from 'react';
import type { Polygon } from 'geojson';
import type { IZone } from 'interfaces/IZone';
import type { GeoJsonPolygon } from 'types/GeoJSONTypes';
import { ZoneLinkType } from 'interfaces/IInput';
import type { MapFeature } from './types';
import PaddockMapCanvas from './components/PaddockMapCanvas';

interface Props {
  zones: IZone[];
  highlightedZoneId: string | null;
  onPaddockSelect: (paddockId: string) => void;
}

const MapView = ({ zones, highlightedZoneId, onPaddockSelect }: Props) => {
  const features = useMemo((): MapFeature[] =>
    zones
      .filter((z) => z.isActive && z.geoData?.type === 'Polygon')
      .map((z) => {
        const paddockLink = z.links.find(
          (l) => l.linkType === ZoneLinkType.Paddock
        );
        return {
          id: z.id,
          name: paddockLink?.snapLinkName ?? z.zoneName ?? 'Unnamed',
          area: Math.round(z.zoneArea * 100) / 100,
          geometry: z.geoData as GeoJsonPolygon as Polygon,
          zoneType: z.zoneType,
          zoneName: z.zoneName ?? '',
          paddockId: paddockLink?.linkId ?? null,
          areaUnit: z.areaUnit?.unit ?? null,
        };
      }),
    [zones]
  );

  return (
    <div className="relative min-h-0 flex-1">
      <PaddockMapCanvas
        features={features}
        highlightedZoneId={highlightedZoneId}
        onPaddockSelect={onPaddockSelect}
      />
    </div>
  );
};

export default MapView;
